import { lt, showSuccessAlert } from '@mews/framework';
import { Divider, DropDownButton, DropdownItem, IconName } from '@optimus-web/core';
import { copyToClipboard } from '@mews-commander/utils';
import { ProductType } from '@mews-commander/data-access';
import { useProductSidePanelContext } from '../sidePanel/ProductSidePanelContext';
import { useDeleteProductDialog } from '../../hooks/useDeleteProductDialog';
import { useEditProductDialogForm } from '../../forms/useEditProductDialogForm';
import { useIsProductCentrallyManaged } from '../../hooks/useIsProductCentrallyManaged';
import { useEditAllowanceDialogForm } from '../../forms/useEditAllowanceDialogForm';

interface Props {
    productId: string;
    productType: ProductType;
}

export const RowActionButton = ({ productId, productType }: Props) => {
    const { open, close } = useProductSidePanelContext();
    const { confirmationDialog: productConfirmationDialog, openConfirmationDialog: openProductConfirmationDialog } =
        useDeleteProductDialog({
            productId,
            onSuccess: close,
        });

    const [renderEditProductDialog, toggleEditProductDialog] = useEditProductDialogForm({ productId });
    const [renderEditAllowanceDialog, toggleEditAllowanceDialog] = useEditAllowanceDialogForm({ productId });

    const isCentrallyManaged = useIsProductCentrallyManaged({ productId });
    const isProductAction = productType === ProductType.Product;

    return (
        <>
            <DropDownButton icon={IconName.More} size="small" variant="ghost">
                <DropdownItem label={lt('ViewDetails')} onClick={() => open(productId, productType)} />
                <DropdownItem
                    label={lt('Edit')}
                    onClick={() => (isProductAction ? toggleEditProductDialog() : toggleEditAllowanceDialog())}
                />
                <DropdownItem
                    label={lt('CopyProductId')}
                    onClick={() => {
                        if (copyToClipboard(productId)) {
                            showSuccessAlert({ description: lt('CopiedSuccessMessage') });
                        }
                    }}
                />
                {!isCentrallyManaged ? (
                    <>
                        <Divider />
                        <DropdownItem
                            label={lt('Delete')}
                            variant="danger"
                            onClick={
                                isProductAction
                                    ? openProductConfirmationDialog
                                    : // HERE COMES THE ALLOWANCE CONFIRMATION DIALOG
                                      () => {}
                            }
                        />
                    </>
                ) : null}
            </DropDownButton>
            {productConfirmationDialog}
            {renderEditProductDialog()}
            {renderEditAllowanceDialog()}
        </>
    );
};
